module.exports = __webpack_public_path__ + "img/book-tanakh.3bcb6d74.svg";